import axiosInstance from "../../axios/axiosInstance";
import { BRAND_LISTING_URL, BRANDS_SINGLE_LISTING, CREATE_BRAND_URL, DELETE_BRAND_CATEGORY, DELETE_BRAND_URL, EDIT_BRAND_URL, FETCH_ALL_BRAND_ADMIN, SIZE_CHART_LISTING } from "../../constants";


export const createBrand = (props) => onResponse => {

    try {
        axiosInstance.post(CREATE_BRAND_URL, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const editBrand = (props) => onResponse => {

    try {
        axiosInstance.post(EDIT_BRAND_URL, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const getBrandListing = (props) => onResponse => {
    try {
        let BASE_URL = FETCH_ALL_BRAND_ADMIN
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const fetchAllBrandAdmin = (props) => onResponse => {
    try {
        let BASE_URL = FETCH_ALL_BRAND_ADMIN
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const deleteBrandItem = (id) => onResponse => {

    try {
        axiosInstance.delete(DELETE_BRAND_URL, { data: { id: id } })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const getBrandDetails = (props) => (onResponse) => {
    try {
        axiosInstance
            .post(BRANDS_SINGLE_LISTING, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) { }
};

export const deleteBrandCategory = (brandId, categoryId) => onResponse => {

    try {
        axiosInstance.delete(DELETE_BRAND_CATEGORY, { data: { brandId: brandId, categoryId: categoryId } })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const getSizeChartListingPaginate = (props) => onResponse => {
    const page = props?.page ? props?.page : ""
    const limit = props?.limit ? props?.limit : ""
    let BASE_URL = SIZE_CHART_LISTING + '?page=' + page + '&pageSize=' + limit
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};